import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SystemRunCronPathParameters } from 'api/actions/system-run-cron/system-run-cron-path-parameters';
import { SystemRunCronResponse } from 'api/actions/system-run-cron/system-run-cron-response';

type SystemRunCronQueryParameters = Record<string, any>;

/**
 * The path of the SystemRunCron action.
 */
export const systemRunCronActionPath = new SweetPath<keyof SystemRunCronPathParameters>('/api/system/run-cron', {
  path: '{param}',
});

/**
 * Creates a contextualized SystemRunCron actions.
 */
export default function createSystemRunCronAction(axios: AxiosInstance) {
  return function systemRunCronAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: SystemRunCronQueryParameters } = {}) {
    const path = systemRunCronActionPath.original;

    return axios.request<SystemRunCronResponse, SystemRunCronResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
